export const SET_SAGA_ATIVIDADE = "deca.SET_SAGA_ATIVIDADE";
export const SET_ATIVIDADE = "deca.SET_ATIVIDADE";

export const ADD_SAGA_ATIVIDADE = "deca.ADD_SAGA_ATIVIDADE";
export const ADD_ATIVIDADE = "deca.ADD_ATIVIDADE";

export const DELETE_SAGA_ATIVIDADE = "deca.DELETE_SAGA_ATIVIDADE";
export const DELETE_ATIVIDADE = "deca.DELETE_ATIVIDADE";
export const CLEAR_GRID_ATIVIDADE = "deca.CLEAR_GRID_ATIVIDADE";
export const SAGA_ATIVIDADE_REMOVER_BY_CNAE =
  "deca.SAGA_ATIVIDADE_REMOVER_BY_CNAE";
export const REDUCER_ATIVIDADE_REMOVER_BY_CNAE =
  "deca.REDUCER_ATIVIDADE_REMOVER_BY_CNAE";

export const MAIN_SAGA_ATIVIDADE = "deca.MAIN_SAGA_ATIVIDADE";
export const MAIN_ATIVIDADE = "deca.MAIN_ATIVIDADE";
export const ON_CHANGE_ATIVIDADE = "deca.ON_CHANGE_ATIVIDADE";
export const ADD_LISTA_ATIVIDADE = 'deca.ADD_LISTA_ATIVIDADE';

